// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setUp[data-v-19f557cd] .ivu-tabs-nav-scroll{padding:0 30px}.setUp[data-v-19f557cd] .ivu-tabs-nav .ivu-tabs-tab{padding:8px 45px}", ""]);
// Exports
module.exports = exports;
